import { POS_DRAFTS_SET } from "./actionTypes";

const initialState = { drafts: [] };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_DRAFTS_SET:
      return { ...state, drafts: action.payload };
    default:
      return state;
  }
}
